import { get, patch } from '@fable/api'
import { ReadingGoal, ReadingGoalPeriodType, ReadingGoalType } from '../types'

export const getReadingGoals = async ({
  userId,
  period,
  year,
}: {
  userId: string
  period?: ReadingGoalPeriodType
  year?: number
}): Promise<ReadingGoal[]> => {
  let url = `/v2/reading/goals/users/${userId}/`
  const params = new URLSearchParams()

  if (!!period?.length) params.set('period_type', period)
  if (!!year) params.set('year', year.toString())

  if (Array.from(params).length > 0) {
    url += `?${params.toString()}`
  }

  const { data } = await get(url)
  return data
}

export const getGoalSuggestions = async ({
  userId,
  period,
}: {
  userId: string
  period?: ReadingGoalPeriodType
}) => {
  const { data } = await get(
    `/v2/reading/goals/users/${userId}/suggestions?period_type=${period}`
  )
  return data
}

export const updateGoalSuggestionPrefs = async ({
  userId,
  period,
  goalType,
}: {
  userId: string
  period: ReadingGoalPeriodType
  goalType: ReadingGoalType
}) => {
  const goalPeriod = period === 'year' ? 'annual' : `${period}ly`
  const key = `hide_${goalPeriod}_${goalType}`

  patch(`/v2/users/${userId}/prefs`, { [key]: true })
}
